import React from "react";
import Nav from "components/layout/Nav";
import {MenuBar} from "components/layout/MenuBar";

const AdminHome = () => {
    return (
        <>
            <Nav />
            <div className="row">
                <MenuBar />
                <main style={{ width: "calc(100vw - 240px)", backgroundColor: "#D0D5DD", }}>
                    dashboard
                </main>
            </div>
        </>
    )
}
export default AdminHome;   